<template>
  <div
    v-if="banners?.length"
    class="catalog-banners"
  >
    <ul
      class="catalog-banners__list"
      :style="`--columns: ${banners.length};`"
    >
      <li
        v-for="banner in banners?.slice(0, 3)"
        :key="banner"
        class="catalog-banners__item"
      >
        <StrapiBanner
          :banner="banner"
          class="catalog-banners__banner"
          :lazy="false"
          :banner-count="banners?.length"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  banners: any[]
}>()
</script>

<style>
@import url("~layers/app/components/Catalog/Banners.css");
</style>
